module.exports = __webpack_public_path__ + "static/media/1_pl.f4b0e16c.png";